module.exports = __webpack_public_path__ + "img/a5ca48ce36f577f77dd1ade1c11c435d.png";